export const LANGUAGE_KEY_AF = 'af' // 南非荷兰语
export const LANGUAGE_KEY_SQ = 'sq' // 南非荷兰语
export const LANGUAGE_KEY_AR = 'ar' // 阿拉伯语
export const LANGUAGE_KEY_HY = 'hy' // 亚美尼亚语
export const LANGUAGE_KEY_AZ = 'az' // 阿泽里语
export const LANGUAGE_KEY_EU = 'eu' // 巴斯克语
export const LANGUAGE_KEY_BE = 'be' // 白俄罗斯语
export const LANGUAGE_KEY_BG = 'bg' // 保加利亚语
export const LANGUAGE_KEY_CA = 'ca' // 加泰罗尼亚语
export const LANGUAGE_KEY_ZH = 'zh' // 中文
export const LANGUAGE_KEY_HR = 'hr' // 克罗地亚语
export const LANGUAGE_KEY_CS = 'cs' // 捷克语
export const LANGUAGE_KEY_DA = 'da' // 丹麦语
export const LANGUAGE_KEY_DV = 'dv' // 迪维希语
export const LANGUAGE_KEY_NL = 'nl' // 荷兰语
export const LANGUAGE_KEY_EN = 'en' // 英语
export const LANGUAGE_KEY_ET = 'et' // 爱沙尼亚语
export const LANGUAGE_KEY_FO = 'fo' // 法罗语
export const LANGUAGE_KEY_FA = 'fa' // 波斯语
export const LANGUAGE_KEY_FI = 'fi' // 芬兰语
export const LANGUAGE_KEY_FR = 'fr' // 法语
export const LANGUAGE_KEY_GL = 'gl' // 加利西亚语
export const LANGUAGE_KEY_KA = 'ka' // 格鲁吉亚语
export const LANGUAGE_KEY_DE = 'de' // 德语
export const LANGUAGE_KEY_EL = 'el' // 希腊语
export const LANGUAGE_KEY_GU = 'gu' // 古吉拉特语
export const LANGUAGE_KEY_HE = 'he' // 希伯来语
export const LANGUAGE_KEY_HI = 'hi' // 印地语
export const LANGUAGE_KEY_HU = 'hu' // 匈牙利语
export const LANGUAGE_KEY_IS = 'is' // 冰岛语
export const LANGUAGE_KEY_ID = 'id' // 印度尼西亚语
export const LANGUAGE_KEY_IT = 'it' // 意大利语
export const LANGUAGE_KEY_JA = 'ja' // 日语
export const LANGUAGE_KEY_KN = 'kn' // 卡纳达语
export const LANGUAGE_KEY_KK = 'kk' // 哈萨克语
export const LANGUAGE_KEY_KOK = 'kok' // 贡根语
export const LANGUAGE_KEY_KO = 'ko' // 朝鲜语
export const LANGUAGE_KEY_KY = 'ky' // 吉尔吉斯语
export const LANGUAGE_KEY_LV = 'lv' // 拉脱维亚语
export const LANGUAGE_KEY_LT = 'lt' // 立陶宛语
export const LANGUAGE_KEY_MK = 'mk' // 马其顿语
export const LANGUAGE_KEY_MS = 'ms' // 马来语
export const LANGUAGE_KEY_MR = 'mr' // 马拉地语
export const LANGUAGE_KEY_MN = 'mn' // 蒙古语
export const LANGUAGE_KEY_NO = 'no' // 挪威语
export const LANGUAGE_KEY_PL = 'pl' // 波兰语
export const LANGUAGE_KEY_PT = 'pt' // 葡萄牙语
export const LANGUAGE_KEY_PA = 'pa' // 旁遮普语
export const LANGUAGE_KEY_RO = 'ro' // 罗马尼亚语
export const LANGUAGE_KEY_RU = 'ru' // 俄语
export const LANGUAGE_KEY_SA = 'sa' // 梵语
export const LANGUAGE_KEY_SR = 'sr' // 塞尔维亚语
export const LANGUAGE_KEY_SK = 'sk' // 斯洛伐克语
export const LANGUAGE_KEY_SL = 'sl' // 斯洛文尼亚语
export const LANGUAGE_KEY_ES = 'es' // 西班牙语
export const LANGUAGE_KEY_SW = 'sw' // 斯瓦希里语
export const LANGUAGE_KEY_SV = 'sv' // 瑞典语
export const LANGUAGE_KEY_SYR = 'syr' // 叙利亚语
export const LANGUAGE_KEY_TA = 'ta' // 泰米尔语
export const LANGUAGE_KEY_TT = 'tt' // 鞑靼语
export const LANGUAGE_KEY_TE = 'te' // 泰卢固语
export const LANGUAGE_KEY_TH = 'th' // 泰语
export const LANGUAGE_KEY_TR = 'tr' // 土耳其语
export const LANGUAGE_KEY_UK = 'uk' // 乌克兰语
export const LANGUAGE_KEY_UR = 'ur' // 乌尔都语
export const LANGUAGE_KEY_UZ = 'uz' // 乌兹别克语
export const LANGUAGE_KEY_VI = 'vi' // 越南语

export const LANGUAGE_MAP = {
  'zh-HK': LANGUAGE_KEY_ZH, // 中文（香港特别行政区，中国）
  'zh-MO': LANGUAGE_KEY_ZH, // 中文（澳门特别行政区）
  'zh-CN': LANGUAGE_KEY_ZH, // 中文（中国）
  'zh-Hans': LANGUAGE_KEY_ZH, // 中文（简体）
  'zh-SG': LANGUAGE_KEY_ZH, // 中文（新加坡）
  'zh-TW': LANGUAGE_KEY_ZH, // 中文（台湾）
  'zh-Hant': LANGUAGE_KEY_ZH, // 中文（繁体）
  zh: LANGUAGE_KEY_ZH, // 中文

  cs: LANGUAGE_KEY_CS, // 捷克语
  'cs-CZ': LANGUAGE_KEY_CS, // 捷克语（捷克共和国）

  nl: LANGUAGE_KEY_NL, // 荷兰语
  'nl-BE': LANGUAGE_KEY_NL, // 荷兰语（比利时）
  'nl-NL': LANGUAGE_KEY_NL, // 荷兰语（荷兰）

  en: LANGUAGE_KEY_EN, // 英语
  'en-AU': LANGUAGE_KEY_EN, // 英语（澳大利亚）
  'en-BZ': LANGUAGE_KEY_EN, // 英语（伯利兹）
  'en-CA': LANGUAGE_KEY_EN, // 英语（加拿大）
  'en-029': LANGUAGE_KEY_EN, // 英语（加勒比）
  'en-IE': LANGUAGE_KEY_EN, // 英语（爱尔兰）
  'en-JM': LANGUAGE_KEY_EN, // 英语（牙买加）
  'en-NZ': LANGUAGE_KEY_EN, // 英语（新西兰）
  'en-PH': LANGUAGE_KEY_EN, // 英语（菲律宾）
  'en-ZA': LANGUAGE_KEY_EN, // 英语（南非）
  'en-TT': LANGUAGE_KEY_EN, // 英语（特立尼达和多巴哥）
  'en-GB': LANGUAGE_KEY_EN, // 英语（英国）
  'en-US': LANGUAGE_KEY_EN, // 英语（美国）
  'en-ZW': LANGUAGE_KEY_EN, // 英语（津巴布韦）

  fi: LANGUAGE_KEY_FI, // 芬兰语
  'fi-FI': LANGUAGE_KEY_FI, // 芬兰语（芬兰）

  fr: LANGUAGE_KEY_FR, // 法语
  'fr-BE': LANGUAGE_KEY_FR, // 法语（比利时）
  'fr-CA': LANGUAGE_KEY_FR, // 法语（加拿大）
  'fr-FR': LANGUAGE_KEY_FR, // 法语（法国）
  'fr-LU': LANGUAGE_KEY_FR, // 法语（卢森堡）
  'fr-MC': LANGUAGE_KEY_FR, // 法语（摩纳哥）
  'fr-CH': LANGUAGE_KEY_FR, // 法语（瑞士）

  de: LANGUAGE_KEY_DE, // 德语
  'de-AT': LANGUAGE_KEY_DE, // 德语（奥地利）
  'de-DE': LANGUAGE_KEY_DE, // 德语（德国）
  'de-LI': LANGUAGE_KEY_DE, // 德语（列支敦士登）
  'de-LU': LANGUAGE_KEY_DE, // 德语（卢森堡）
  'de-CH': LANGUAGE_KEY_DE, // 德语（瑞士）

  el: LANGUAGE_KEY_EL, // 希腊语
  'el-GR': LANGUAGE_KEY_EL, // 希腊语（希腊）

  hu: LANGUAGE_KEY_HU, // 匈牙利语
  'hu-HU': LANGUAGE_KEY_HU, // 匈牙利语（匈牙利）

  it: LANGUAGE_KEY_IT, // 意大利语
  'it-IT': LANGUAGE_KEY_IT, // 意大利语（意大利）
  'it-CH': LANGUAGE_KEY_IT, // 意大利语（瑞士）

  ja: LANGUAGE_KEY_JA, // 日语
  'ja-JP': LANGUAGE_KEY_JA, // 日语（日本）

  pl: LANGUAGE_KEY_PL, // 波兰语
  'pl-PL': LANGUAGE_KEY_PL, // 波兰语（波兰）

  pt: LANGUAGE_KEY_PT, // 葡萄牙语
  'pt-BR': LANGUAGE_KEY_PT, // 葡萄牙语（巴西）
  'pt-PT': LANGUAGE_KEY_PT, // 葡萄牙语（葡萄牙）

  ru: LANGUAGE_KEY_RU, // 俄语
  'ru-RU': LANGUAGE_KEY_RU, // 俄语（俄罗斯）

  es: LANGUAGE_KEY_ES, // 西班牙语
  'es-AR': LANGUAGE_KEY_ES, // 西班牙语（阿根廷）
  'es-BO': LANGUAGE_KEY_ES, // 西班牙语（玻利维亚）
  'es-CL': LANGUAGE_KEY_ES, // 西班牙语（智利）
  'es-CO': LANGUAGE_KEY_ES, // 西班牙语（哥伦比亚）
  'es-CR': LANGUAGE_KEY_ES, // 西班牙语（哥斯达黎加）
  'es-DO': LANGUAGE_KEY_ES, // 西班牙语（多米尼加共和国）
  'es-EC': LANGUAGE_KEY_ES, // 西班牙语（厄瓜多尔）
  'es-SV': LANGUAGE_KEY_ES, // 西班牙语（萨尔瓦多）
  'es-GT': LANGUAGE_KEY_ES, // 西班牙语（危地马拉）
  'es-HN': LANGUAGE_KEY_ES, // 西班牙语（洪都拉斯）
  'es-MX': LANGUAGE_KEY_ES, // 西班牙语（墨西哥）
  'es-NI': LANGUAGE_KEY_ES, // 西班牙语（尼加拉瓜）
  'es-PA': LANGUAGE_KEY_ES, // 西班牙语（巴拿马）
  'es-PY': LANGUAGE_KEY_ES, // 西班牙语（巴拉圭）
  'es-PE': LANGUAGE_KEY_ES, // 西班牙（秘鲁）
  'es-PR': LANGUAGE_KEY_ES, // 西班牙语（波多黎各）
  'es-ES': LANGUAGE_KEY_ES, // 西班牙语（西班牙）
  'es-UY': LANGUAGE_KEY_ES, // 西班牙语（乌拉圭）
  'es-VE': LANGUAGE_KEY_ES, // 西班牙语（委内瑞拉）

  sv: LANGUAGE_KEY_SV, // 瑞典语
  'sv-FI': LANGUAGE_KEY_SV, // 瑞典语（芬兰）
  'sv-SE': LANGUAGE_KEY_SV, // 瑞典语（瑞典）

  th: LANGUAGE_KEY_TH, // 泰语
  'th-TH': LANGUAGE_KEY_TH, // 泰语（泰国）

  tr: LANGUAGE_KEY_TR, // 土耳其语
  'tr-TR': LANGUAGE_KEY_TR, // 土耳其语（土耳其）

  vi: LANGUAGE_KEY_VI, // 越南语
  'vi-VN': LANGUAGE_KEY_VI, // 越南语（越南）

  ko: LANGUAGE_KEY_KO, // 朝鲜语
  'ko-KR': LANGUAGE_KEY_KO, // 朝鲜语（韩国）

  bg: LANGUAGE_KEY_BG, // 保加利亚语
  'bg-BG': LANGUAGE_KEY_BG, // 保加利亚语（保加利亚）

  da: LANGUAGE_KEY_DA, // 丹麦语
  'da-DK': LANGUAGE_KEY_DA, // 丹麦语（丹麦）

  et: LANGUAGE_KEY_ET, // 爱沙尼亚语
  'et-EE': LANGUAGE_KEY_ET, // 爱沙尼亚语（爱沙尼亚）

  hr: LANGUAGE_KEY_HR, // 克罗地亚语
  'hr-HR': LANGUAGE_KEY_HR, // 克罗地亚语（克罗地亚）

  lt: LANGUAGE_KEY_LT, // 立陶宛语
  'lt-LT': LANGUAGE_KEY_LT, // 立陶宛语（立陶宛）

  lv: LANGUAGE_KEY_LV, // 拉脱维亚语
  'lv-LV': LANGUAGE_KEY_LV, // 拉脱维亚语（拉脱维亚）

  ro: LANGUAGE_KEY_RO, // 罗马尼亚语
  'ro-RO': LANGUAGE_KEY_RO, // 罗马尼亚语（罗马尼亚）

  sk: LANGUAGE_KEY_SK, // 斯洛伐克语
  'sk-SK': LANGUAGE_KEY_SK, // 斯洛伐克语（斯洛伐克）

  sl: LANGUAGE_KEY_SL, // 斯洛文尼亚语
  'sl-SI': LANGUAGE_KEY_SL, // 斯洛文尼亚语（斯洛文尼亚）

  // af: LANGUAGE_KEY_AF, // 南非荷兰语
  // 'af-ZA': LANGUAGE_KEY_AF, // 南非荷兰语（南非）

  // sq: LANGUAGE_KEY_SQ, // 阿尔巴尼亚语
  // 'sq-AL': LANGUAGE_KEY_SQ, // 阿尔巴尼亚语（阿尔巴尼亚）

  // ar: LANGUAGE_KEY_AR, // 阿拉伯语
  // 'ar-DZ': LANGUAGE_KEY_AR, // 阿拉伯语（阿尔及利亚）
  // 'ar-BH': LANGUAGE_KEY_AR, // 阿拉伯语（巴林）
  // 'ar-EG': LANGUAGE_KEY_AR, // 阿拉伯语（埃及）
  // 'ar-IQ': LANGUAGE_KEY_AR, // 阿拉伯语（伊拉克）
  // 'ar-JO': LANGUAGE_KEY_AR, // 阿拉伯语（约旦）
  // 'ar-KW': LANGUAGE_KEY_AR, // 阿拉伯语（科威特）
  // 'ar-LB': LANGUAGE_KEY_AR, // 阿拉伯语（黎巴嫩）
  // 'ar-LY': LANGUAGE_KEY_AR, // 阿拉伯语（利比亚）
  // 'ar-MA': LANGUAGE_KEY_AR, // 阿拉伯语（摩洛哥）
  // 'ar-OM': LANGUAGE_KEY_AR, // 阿拉伯语（阿曼）
  // 'ar-QA': LANGUAGE_KEY_AR, // 阿拉伯语（卡塔尔）
  // 'ar-SA': LANGUAGE_KEY_AR, // 阿拉伯语（沙特阿拉伯）
  // 'ar-SY': LANGUAGE_KEY_AR, // 阿拉伯语（叙利亚）
  // 'ar-TN': LANGUAGE_KEY_AR, // 阿拉伯语（突尼斯）
  // 'ar-AE': LANGUAGE_KEY_AR, // 阿拉伯语（阿联酋）
  // 'ar-YE': LANGUAGE_KEY_AR, // 阿拉伯语（也门）

  // hy: LANGUAGE_KEY_HY, // 亚美尼亚语
  // 'hy-AM': LANGUAGE_KEY_HY, // 亚美尼亚语（亚美尼亚）

  // az: LANGUAGE_KEY_AZ, // 阿泽里语
  // 'az-Cyrl-AZ': LANGUAGE_KEY_AZ, // 阿泽里语（阿塞拜疆，西里尔语）
  // 'az-Latn-AZ': LANGUAGE_KEY_AZ, // 阿泽里语（阿塞拜疆，拉丁语）

  // eu: LANGUAGE_KEY_EU, // 巴斯克语
  // 'eu-ES': LANGUAGE_KEY_EU, // 巴斯克语（巴斯克地区）

  // be: LANGUAGE_KEY_BE, // 白俄罗斯语
  // 'be-BY': LANGUAGE_KEY_BE, // 白俄罗斯语（白俄罗斯）

  // ca: LANGUAGE_KEY_CA, // 加泰罗尼亚语
  // 'ca-ES': LANGUAGE_KEY_CA, // 加泰罗尼亚语（加泰罗尼亚地区）

  // dv: LANGUAGE_KEY_DV, // 迪维希语
  // 'dv-MV': LANGUAGE_KEY_DV, // 迪维希语（马尔代夫）

  // fo: LANGUAGE_KEY_FO, // 法罗语
  // 'fo-FO': LANGUAGE_KEY_FO, // 法罗语（法罗群岛）

  // fa: LANGUAGE_KEY_FA, // 波斯语
  // 'fa-IR': LANGUAGE_KEY_FA, // 波斯语（伊朗）

  // gl: LANGUAGE_KEY_GL, // 加利西亚语
  // 'gl-ES': LANGUAGE_KEY_GL, // 加利西亚语（西班牙）

  // ka: LANGUAGE_KEY_KA, // 格鲁吉亚语
  // 'ka-GE': LANGUAGE_KEY_KA, // 格鲁吉亚语（格鲁吉亚）

  // gu: LANGUAGE_KEY_GU, // 古吉拉特语
  // 'gu-IN': LANGUAGE_KEY_GU, // 古吉拉特语（印度）

  // he: LANGUAGE_KEY_HE, // 希伯来语
  // 'he-IL': LANGUAGE_KEY_HE, // 希伯来语（以色列）

  // hi: LANGUAGE_KEY_HI, // 印地语
  // 'hi-IN': LANGUAGE_KEY_HI, // 印地语（印度）

  // is: LANGUAGE_KEY_IS, // 冰岛语
  // 'is-IS': LANGUAGE_KEY_IS, // 冰岛语（冰岛）

  // id: LANGUAGE_KEY_ID, // 印度尼西亚语
  // 'id-ID': LANGUAGE_KEY_ID, // 印度尼西亚语（印度尼西亚）

  // kn: LANGUAGE_KEY_KN, // 卡纳达语
  // 'kn-IN': LANGUAGE_KEY_KN, // 卡纳达语（印度）

  // kk: LANGUAGE_KEY_KK, // 哈萨克语
  // 'kk-KZ': LANGUAGE_KEY_KK, // 哈萨克语（哈萨克斯坦）

  // kok: LANGUAGE_KEY_KOK, // 贡根语
  // 'kok-IN': LANGUAGE_KEY_KOK, // 贡根语（印度）

  // ky: LANGUAGE_KEY_KY, // 吉尔吉斯语
  // 'ky-KG': LANGUAGE_KEY_KY, // 吉尔吉斯语（吉尔吉斯坦）

  // mk: LANGUAGE_KEY_MK, // 马其顿语
  // 'mk-MK': LANGUAGE_KEY_MK, // 马其顿语（马其顿，FYROM）

  // ms: LANGUAGE_KEY_MS, // 马来语
  // 'ms-BN': LANGUAGE_KEY_MS, // 马来语（文莱达鲁萨兰）
  // 'ms-MY': LANGUAGE_KEY_MS, // 马来语（马来西亚）

  // mr: LANGUAGE_KEY_MR, // 马拉地语
  // 'mr-IN': LANGUAGE_KEY_MR, // 马拉地语（印度）

  // mn: LANGUAGE_KEY_MN, // 蒙古语
  // 'mn-MN': LANGUAGE_KEY_MN, // 蒙古语（蒙古）

  // no: LANGUAGE_KEY_NO, // 挪威语
  // 'nb-NO': LANGUAGE_KEY_NO, // 挪威语（伯克梅尔，挪威）
  // 'nn-NO': LANGUAGE_KEY_NO, // 挪威语（尼诺斯克，挪威）

  // pa: LANGUAGE_KEY_PA, // 旁遮普语
  // 'pa-IN': LANGUAGE_KEY_PA, // 旁遮普语（印度）

  // sa: LANGUAGE_KEY_SA, // 梵语
  // 'sa-IN': LANGUAGE_KEY_SA, // 梵语（印度）

  // 'sr-Cyrl-CS': LANGUAGE_KEY_SR, // 塞尔维亚语（塞尔维亚，西里尔语）
  // 'sr-Latn-CS': LANGUAGE_KEY_SR, // 塞尔维亚语（塞尔维亚，拉丁语）

  // sw: LANGUAGE_KEY_SW, // 斯瓦希里语
  // 'sw-KE': LANGUAGE_KEY_SW, // 斯瓦希里语（肯尼亚）

  // syr: LANGUAGE_KEY_SYR, // 叙利亚语
  // 'syr-SY': LANGUAGE_KEY_SYR, // 叙利亚语（叙利亚）

  // ta: LANGUAGE_KEY_TA, // 泰米尔语
  // 'ta-IN': LANGUAGE_KEY_TA, // 泰米尔语（印度）

  // tt: LANGUAGE_KEY_TT, // 鞑靼语
  // 'tt-RU': LANGUAGE_KEY_TT, // 鞑靼语（俄罗斯）

  // te: LANGUAGE_KEY_TE, // 泰卢固语
  // 'te-IN': LANGUAGE_KEY_TE, // 泰卢固语（印度）

  // uk: LANGUAGE_KEY_UK, // 乌克兰语
  // 'uk-UA': LANGUAGE_KEY_UK, // 乌克兰语（乌克兰）

  // ur: LANGUAGE_KEY_UR, // 乌尔都语
  // 'ur-PK': LANGUAGE_KEY_UR, // 乌尔都语（巴基斯坦）

  // uz: LANGUAGE_KEY_UZ, // 乌兹别克语
  // 'uz-Cyrl-UZ': LANGUAGE_KEY_UZ, // 乌兹别克语（乌兹别克斯坦，西里尔语）
  // 'uz-Latn-UZ': LANGUAGE_KEY_UZ, // 乌兹别克语（乌兹别克斯坦，拉丁语）
}
